import React from 'react';
import ReactLoading from 'react-loading';

export default function TableLoading() {
  return (
    <div className="tableLoadingContainer">
      <ReactLoading type="spin" color="#08798E" />
    </div>
  );
}